// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.layout-header[data-v-8f858a1e] {\n  height: auto;\n  min-height: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
